<script lang="ts">
    
    import { fly } from 'svelte/transition';
    import { playerPosition } from "../../Services/geolocation";

</script>

{#if !$playerPosition}
    <div class="geolocating" transition:fly={{ y: 30 }}>
        Buscándote...
    </div>
{/if}

<style lang="scss">

    .geolocating {
        $width: 140px;
        position: fixed;
        z-index: 100;
        left: calc(50% - #{$width * 0.5});
        bottom: 0;
        width: $width;
        height: 30px;
        background-color: var(--color-primary);
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.25);
    }

</style>
